export default {
    home: {
      title: 'Home'
    },
    members: {
      title: 'Team'
    },
    publications: {
      title: 'Publications'
    },
    teaching: {
      title: 'Teaching'
    },
    opening: {
      title: 'Opening'
    },
    notFound: {
      title: 'Page not found'
    },
  };
